import { $, Backbone, _ } from "js/vendor";
import { ds } from "js/core/models/dataService";
import { app } from "js/namespaces";

import "css/collaboration-view.scss";

const MAX_USERS_TO_RENDER = 10;

const CollaborationView = Backbone.View.extend({
    initialize: function() {
        this.collaborators = {};

        this.collaboratorsSubscription = ds.getObservables().collaborators$
            .subscribe(collaborators => {
                this.collaborators = collaborators;
                if (app.mainView.editorView) {
                    this.renderCollaborators();
                }
            });
    },

    tagName: "ul",
    className: "collaboration-view",

    render: function() {
        return this;
    },

    renderCollaborators() {
        const $collaboratorsPane = $(".collaborators-pane");

        const collaborators = Object.values(this.collaborators)
            .filter(({ uid }) => uid !== app.user.id);

        const existingUserElements = {};
        const slideGrid = app.mainView.editorView.slideGrid;
        if (slideGrid) {
            slideGrid.slideThumbnails.forEach(slideGridItemView => {
                slideGridItemView.$collaborators.children().each((idx, element) => {
                    const $element = $(element);
                    // Note the slide id check
                    if (!collaborators.some(({ uid, slideId }) => uid === $element.data("uid") && slideId === slideGridItemView.model.id)) {
                        $element.remove();
                    } else {
                        existingUserElements[$element.data("uid")] = $element;
                    }
                });
            });
        } else {
            $collaboratorsPane.children().each((idx, element) => {
                const $element = $(element);
                if (!collaborators.some(({ uid }) => uid === $element.data("uid"))) {
                    $element.remove();
                } else {
                    existingUserElements[$element.data("uid")] = $element;
                }
            });
            this.$el.show();
        }

        collaborators
            .slice(0, MAX_USERS_TO_RENDER)
            .forEach(({ uid, photoURL, displayName, slideId }) => {
                let $user = existingUserElements[uid];
                if (!$user) {
                    $user = $.div("user");
                    $user.data("uid", uid);
                    const $avatar = $.div("avatar").attr("title", displayName);
                    $user.addEl($avatar);

                    if (photoURL) {
                        $avatar.addEl($.img(photoURL));
                    } else {
                        $avatar.html("<i class='micon'>person</i>");
                    }

                    if (app.mainView.editorView.slideGrid) {
                        const slideGridItemView = slideGrid.slideThumbnails.find(slideGridItemView => slideGridItemView.model.id === slideId);
                        if (slideGridItemView) {
                            slideGridItemView.$collaborators.addEl($user);
                        }
                    } else {
                        $collaboratorsPane.addEl($user);
                    }
                }

                if (ds.selection.slide?.id === slideId) {
                    $user.addClass("active");
                } else {
                    $user.removeClass("active");
                }

                // Removing old listeners (if any)
                $user.off("click");
                $user.on("click", () => {
                    app.mainView.editorView.goToSlide(app.mainView.editorView.getSlideById(slideId));
                });
            });

        return this;
    },

    stop() {
        this.collaboratorsSubscription && this.collaboratorsSubscription.unsubscribe();
    }

});

export default CollaborationView;
